import React from 'react';

interface IRadioButtonProps {
    checked: boolean;
    onClick: () => void;
    dataTestId?: string;
}

const RadioButton: React.FC<IRadioButtonProps> = (props) => {
    return <div
        className={`radio-button ${props.checked ? 'radio-button-checked' : 'radio-button-unchecked'}`}
        onClick={props.onClick}
        data-testid={props.dataTestId}
        />
};

export default RadioButton;